import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { FilterResult } from '../../models/filtering/filter-result';
import { TemplateModel } from '../../models/template.model';
import { templateService } from '../../services/TemplateService';
import { getTemplatesQueryKey } from '../../utils/pagination';

export const useGetTemplates = (
  page: number,
  pageSize: number,
  query = '',
  options?: UseQueryOptions<FilterResult<TemplateModel>, Error, FilterResult<TemplateModel>>,
) => {
  return useQuery<FilterResult<TemplateModel>, Error>({
    queryKey: getTemplatesQueryKey(page, pageSize, query),
    queryFn: async () => templateService.getFiltered(page, pageSize, query),
    ...options,
  });
};

export const useGetTemplate = (id: string, options?: UseQueryOptions<any, any, any, any>) => {
  return useQuery<any>({
    queryKey: ['template', id],
    queryFn: async () => templateService.get(id),
    ...options,
  });
};
